// @flow
export const WepPageSupportedLanguages = ['en', 'jp', 'de'];
